import { INIT_PAGE_STATE } from "../../constant/constant";

export const LOG_GET_LIST = "LOG_GET_LIST";
export const LOG_GET_LIST_SUCCESS = "LOG_GET_LIST_SUCCESS";
export const LOG_GET_LIST_ERROR = "LOG_GET_LIST_ERROR";

export const LOG_STORE = "LOG_STORE";
export const LOG_STORE_SCHEDULER = "LOG_STORE_SCHEDULER";

// LOG IMPORT 
export const LOG_IMPORT_GET_LIST = "LOG_IMPORT_GET_LIST";
export const LOG_IMPORT_GET_LIST_SUCCESS = "LOG_IMPORT_GET_LIST_SUCCESS";

/**
 * Load import logs.
 * @param {Object} p - Parameters for fetching import logs.
 * @returns {{ type: string, payload: Object }}
 */
export const loadLogImport = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      orderBy: "createdDate",
      sortedBy: "desc",
      limit: INIT_PAGE_STATE.pageSizes[0],
      // limit: 3,
    },
    ...p,
  };
  return {
    type: LOG_IMPORT_GET_LIST,
    payload: {
      municipal_id: param?.sourced_id,
      selectedPage: param.selectedPage,
      filter: param.filter,
      orderBy: param.orderBy,
      sortedBy: param.sortedBy,
      limit: param.limit,
    },
  };
};

/**
 * Action dispatched when import logs are successfully loaded.
 * @param {Object} data - Loaded log data.
 */
export const loadLogImportSuccess = (data) => ({
  type: LOG_IMPORT_GET_LIST_SUCCESS,
  payload: data,
});

/**
 * Load general logs.
 * @param {Object} p - Parameters for fetching logs.
 * @returns {{ type: string, payload: Object }}
 */
export const loadLog = (p) => {
//console.log({p})
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      importType: '',
      orderBy: "id",
      sortedBy: "desc",
      limit: INIT_PAGE_STATE.pageSizes[0],
      section: "SCHEDULER"
      // limit: 3,
    },
    ...p,
  };
  return {
    type: LOG_GET_LIST,
    payload: {
      municipal_id: param?.sourced_id,
      selectedPage: param.selectedPage,
      filter: param.filter,
      importType: param.importType,
      orderBy: param.orderBy,
      sortedBy: param.sortedBy,
      limit: param.limit,
      title: param.title,
      scheduleJobId: param.scheduleJobId,
      section: param.section,
    },
  };
};

/**
 * Action dispatched when logs are successfully loaded.
 * @param {Object} data - Loaded log data.
 */
export const loadLogSuccess = (data) => ({
  type: LOG_GET_LIST_SUCCESS,
  payload: data,
});

/**
 * Action dispatched when loading logs fails.
 * @param {Error|Object|string} error - Error information.
 */
export const loadLogError = (error) => ({
  type: LOG_GET_LIST_ERROR,
  payload: error,
});

/**
 * Store a single log entry.
 * @param {Object} item - Log entry data to store.
 */
export const storeLog = (item) => ({
  type: LOG_STORE,
  payload: {
    item,
  },
});

/**
 * Store a log entry related to a scheduler.
 * @param {Object} item - Log entry data.
 * @param {string} [query=""] - Optional query string for filtering or extra info.
 */
export const storeLogScheduler = (item, query = "") => ({
  type: LOG_STORE_SCHEDULER,
  payload: {
    item,
    query,
  },
});